import { createSlice } from "@reduxjs/toolkit"

export const tariffRateReducer = createSlice({
    name: 'tariffRateReducer',
    initialState: {
        isLoading: false,
        error: null,
        list: [],
    },
    reducers: {
        setLoading: (state) => {
            state.isLoading = true
        },
        setError: (state, action) => {
            state.isLoading = false
            state.error = action.payload
        },
        getListSuccess: (state, action) => {
			state.isLoading = false
			state.list = action.payload
		},
        clear: (state) => {
            state.isLoading = false
            state.list = []
            state.error = null
        },
    }
})

export default tariffRateReducer.reducer;